import { getNotAvailableMenuItems } from './getNotAvailableMenuItems';

const detectOutOfScheduleItemsInCartFun = (currentOrder, menuItemSchedules) => {
  const notAvailableMenuItems = getNotAvailableMenuItems(menuItemSchedules);

  return currentOrder?.menuItems?.some(({ _id }) => {
    return notAvailableMenuItems[_id];
  });
};

export const detectOutOfScheduleItemsInCart = detectOutOfScheduleItemsInCartFun;
